/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, PrincipalRolesControllerFindEligiblePrincipalsQueryParams, PrincipalRolesControllerFindEligiblePrincipals401, PrincipalRolesControllerFindEligiblePrincipals403 } from "../../models/principalRolesController/PrincipalRolesControllerFindEligiblePrincipals";

function getPrincipalRolesControllerFindEligiblePrincipalsUrl() {
  const res = { method: 'GET', url: `/api/v1/principal-roles/eligible-principals` as const }  
  return res
}

/**
 * @summary Search people eligible to be assigned or mentioned at a scope
 * {@link /api/v1/principal-roles/eligible-principals}
 */
export async function principalRolesControllerFindEligiblePrincipals(params: PrincipalRolesControllerFindEligiblePrincipalsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PrincipalRolesControllerFindEligiblePrincipalsQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindEligiblePrincipals401 | PrincipalRolesControllerFindEligiblePrincipals403>, unknown>({ method : "GET", url : getPrincipalRolesControllerFindEligiblePrincipalsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}